"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Typography = _interopRequireDefault(require("./Typography"));

var _Text = _interopRequireDefault(require("./Text"));

var _Title = _interopRequireDefault(require("./Title"));

var _Paragraph = _interopRequireDefault(require("./Paragraph"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Typography = _Typography["default"];
Typography.Text = _Text["default"];
Typography.Title = _Title["default"];
Typography.Paragraph = _Paragraph["default"];
var _default = Typography;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/typography/index.js
// module id = 949
// module chunks = 1